export const OutletData = [
  [
    "outlet_name",
    "outlet_unique_id",
    "outlet_contact_number",
    "customer_code",
    "outlet_category",
    "outlet_ccnoms",
    "outlet_ccnohsd",
    "outlet_contact_person_name",
    "primary_number",
    "secondary_number",
    "primary_email",
    "secondary_email",
    "location",
    "address",
    "outlet_resv",
    "outlet_longitude",
    "outlet_lattitude",
    "status",
    "email",
    "password",
  ],
  [
    "Main Street Outlet", // outlet_name
    "OUT123456", // outlet_unique_id
    "+1234567890", // outlet_contact_number
    "CUST001", // customer_code
    "Retail", // outlet_category
    500, // outlet_ccnoms
    300, // outlet_ccnohsd
    "John Doe", // outlet_contact_person_name
    "+1987654321", // primary_number
    "+1234567891", // secondary_number
    "primary@example.com", // primary_email
    "secondary@example.com", // secondary_email
    "Downtown Cityville", // location
    "123 Main Street Cityville", // address
    "Yes", // outlet_resv
    "40.712776", // outlet_longitude
    "-74.005974", // outlet_lattitude
    1, // status (active)
    "outlet@example.com", // email
    "securePassword123", // password
  ],
  [
    "Outlet 2", // outlet_name
    "OUT123456", // outlet_unique_id
    "+1234567890", // outlet_contact_number
    "CUST001", // customer_code
    "Retail", // outlet_category
    500, // outlet_ccnoms
    300, // outlet_ccnohsd
    "John Doe", // outlet_contact_person_name
    "+1987654321", // primary_number
    "+1234567891", // secondary_number
    "primary@example.com", // primary_email
    "secondary@example.com", // secondary_email
    "Downtown Cityville", // location
    "123 Main Street Cityville", // address
    "Yes", // outlet_resv
    "40.712776", // outlet_longitude
    "-74.005974", // outlet_lattitude
    1, // status (active)
    "outlet@example.com", // email
    "securePassword123", // password
  ],
];
